module.exports = __webpack_public_path__ + "images/pro-trial-golf-onboarding.48466787d73be0b45ff227eacbc4fe05.png";